module.exports = "/fonts/vendor/video.js/dist/VideoJS.eot?f72fc39ed5340b2def6b82fb0002019a";